<header class="b-top border-xl core-water-leaf-border">
  <a href="/"><img width="200px" src="./assets/alight_worklife_logo_black.svg" /></a>
  <div class="profile">

    <a class="user-profile" routerLink="/settings" routerLinkActive="active" ariaCurrentWhenActive="page">
      <fa-icon [icon]="faCircleUser"></fa-icon>
    </a>

    <span style="color: rgb(20, 134, 249);" class="language-selection">
      <fa-icon [icon]="faGlobe"></fa-icon>
      EN
    </span>
  </div>
</header>